// tslint:disable-next-line:no-var-requires
import {UtilityHelper} from "@/helpers/UtilityHelper";

require("@/libraries/adjust.min");
// @ts-ignore
const Adjust = window.Adjust;

/**
 * @class AdjustService Handles device tracking
 */
export class AdjustService {
  private readonly mode: string | undefined = process.env.NODE_ENV;
  private readonly devices: any = {};
  private readonly adjust: any;
  private readonly finishFormButtonToken: string = UtilityHelper.isOandaPath() ? "16m9jc" : "llcyh1";
  private readonly tmsAppToken: string = 'hwl1tuxazy80';
  private readonly oandaAppToken: string = 'h9dd9bvlbsao';
  private readonly deviceIds: string[] = [
    "android_id",
    "android_id_lower_md5",
    "android_id_lower_sha1",
    "android_id_upper_md5",
    "android_id_upper_sha1",
    "idfv",
    "idfa",
    "mac_upper_short_md5",
    "mac_upper_sha1",
    "win_naid",
    "win_hwid",
    "fire_adid",
    "gps_adid",
    "gps_adid_upper_md5",
    "gps_adid_upper_sha1",
    "gps_adid_lower_sha1",
    "idfa_lower_md5",
    "idfa_lower_sha1",
    "idfa_upper_md5",
    "idfa_upper_sha1",
    "idfa_short",
    "win_adid",
    "gadid",
  ];

  constructor() {
    let adId = null;
    let os = "";
    const queryString = window.location.search.slice(1, window.location.search.length).split("&");
    const t = this;

    // <editor-fold desc="Load tracking params from querystring">
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < queryString.length; i++) {
      if (queryString[i].startsWith("adid")) {
        adId = queryString[i].split("=")[1];
      } else {
        // tslint:disable-next-line: prefer-for-of
        for (let j = 0; j < this.deviceIds.length; j++) {
          if (queryString[i].startsWith(this.deviceIds[j])) {
            const entry = queryString[i].split("=");
            // @ts-ignore
            this.devices[entry[0]] = entry[1];
            break;
          }
        }
      }
    }

    if (this.devices.gadid) {
      this.devices.gps_adid = this.devices.gadid;
    }
    // </editor-fold>

    // <editor-fold desc="Determine if device is Android or IOS">
    let isAndroid = false;
    let isIOs = false;
    const keys = Object.keys(this.devices);

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < keys.length; i++) {
      if (keys[i].startsWith("gps_adid") || keys[i].startsWith("android_id")) {
        isAndroid = true;
        break;
      } else if (keys[i].startsWith("idfa") || keys[i].startsWith("idfv") || keys[i].startsWith("mac")) {
        isIOs = true;
        break;
      }
    }

    if (navigator.userAgent.indexOf("Android") > -1 || isAndroid) {
      os = "android";
    } else if (navigator.userAgent.indexOf("iPhone") > -1 || isIOs) {
      os = "ios";
    }
    // </editor-fold>

    // <editor-fold desc="Start tracking session">
    const config = {
      app_token: UtilityHelper.isOandaPath() ? this.oandaAppToken: this.tmsAppToken,
      environment: "production", // || 'sandbox'
      os_name: os,
      device_ids: Object.assign(
        {
          adid: adId,
        },
        this.devices
      ),
    };

    this.adjust = new Adjust(config);

    try {
      this.adjust.trackSession(
        function (result: any) {
          if (t.mode !== "production") {
            console.info(result);
          }
          // tslint:disable-next-line: only-arrow-functions
        },
        function (errorMsg: any, error: any) {
          // this error is not a problem, external service intentionally throws 500 if session occurs too frequently
          console.info(errorMsg, error);
        }
      );
    } catch (e) {
      console.error(e)
    }
    // </editor-fold>
  }

  /**
   * Pushes event indicating that onboarding has been completed
   */
  private pushOnboardingFinish() {
    try {
      this.adjust.trackEvent(
        {
          event_token: this.finishFormButtonToken,
          // tslint:disable-next-line: only-arrow-functions
        },
        function (result: any) {
          console.info(result, "event");
          // tslint:disable-next-line: only-arrow-functions
        },
        function (errorMsg: any, error: any) {
          console.info(errorMsg, error, "event");
        }
      );
    } catch (e) {
      console.error(e)
    }
  }

  public push(name: string) {
    if (name === "errorsReport") {
      this.pushOnboardingFinish();
    }
  }
}
